import { observer } from 'mobx-react';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import * as React from 'react';
import { SideTitle } from '../SideTitle';
import { getFaqs } from 'utils';
import s from './Faq.scss';
import { FaqItem } from './FaqItem';
import { FaqSideSubtitle } from './FaqSubtitle';

export interface FaqProps {
  rootStore: RootStore;
  isEnterpriseFaqs: boolean;
}

const FaqsComp: React.FC<FaqProps> = ({ isEnterpriseFaqs, rootStore }) => {
  const { theme } = usePageModeContext();
  const { hasGoogleVoucher, country } = rootStore.appStore.appContext;
  const { isFranchPackagePicker, isJapanesePackagePicker } = rootStore.appStore;
  const localizedFaqs = isFranchPackagePicker || isJapanesePackagePicker;
  const faqs = getFaqs({
    hasGoogleVoucher,
    theme,
    isEnterprisePlanType: isEnterpriseFaqs,
    localizedFaqs,
    country,
  });

  return (
    <div className={s.faqContainer}>
      <div className={s.innerContainer}>
        <SideTitle titleKey='faq_section.faq_title'>
          <FaqSideSubtitle />
        </SideTitle>
        <div className={s.faqListContainer} data-testid='faq-list'>
          {Object.values(faqs).map((faq) => (
            <FaqItem
              key={faq}
              faqCode={faq}
              isEnterpriseFaqs={isEnterpriseFaqs}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export const Faq = withInjectedRootStore(observer(FaqsComp));